import { schema } from "normalizr";

export default class ReferrerSchema extends schema.Entity {
  constructor() {
    super("referrer", {}, { idAttribute: "_id" });
  }
}
